import Index from '../components/DownloadOrder/Index';

let routes = {
    path: '/downloadOrder',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/downloadOrder',
            component: Index
        }
    ]
};

export default routes;


// WEBPACK FOOTER //
// ./src/router/downloadOrder.js